import React from 'react';

import imgies from '../img/organizan/logo-ies.png';
import imgdi3d from '../img/organizan/disenio-impresion-3d.png';

export default function Organizan() { 
    

  return (
      <React.Fragment>
        <div className="mt-5 mb-5 referencia text-center">ORGANIZAN</div>
        <ul className="organizan mb-3">
            <li><a href="https://www.ies21.edu.ar/" target="_blank" rel="noreferrer noopener"><img src={imgies} alt="IES 21" /></a></li>
            <li><a href="https://www.ies21.edu.ar/carreras/diseno-e-impresion-3d" target="_blank" rel="noreferrer noopener"><img src={imgdi3d} alt="Diseño Impresión 3d" /></a></li>
        </ul>
      </React.Fragment>
    
  );
}